import api from "@helpers/api";
import { materialWriteBody } from "./materialWriteBody";

/**
 * Create a new material
 * @param {CreateMaterialDTO} materialDTO - Material data transfer object
 * @returns {Promise<{success: boolean, data?: Object, error?: string}>}
 */
export async function createMaterial(materialDTO) {
    try {
        const payload = materialDTO.toPayload();
        const communityId = payload.community;
        const body = materialWriteBody(payload);
        const { data } = await api.post(`community/${communityId}/material`, body);

        if (data.id) {
            return { success: true, data };
        }

        return {
            success: false,
            error: 'Não foi possível criar o material'
        };
    } catch (error) {
        console.error('Error creating material:', error);

        return {
            success: false,
            error: 'Um erro ocorreu ao salvar o material, confira o arquivo inserido e tente novamente'
        };
    }
}
